import Vue from 'vue'
import Router from 'vue-router'

import VueForm from '@/components/Form'
import VueCards from '@/components/Cards'
import PropertyReportQuoteWizard from '@/components/client/PropertyReportQuoteWizard'
import NotFoundError from '@/components/404'
import Layout from '@/components/admin/Layout'
import LiveFeed from '@/components/admin/LiveFeed'
import OCManagersFeed from '@/components/admin/OCManagersFeed'
import QuotesDisplay from '@/components/admin/QuotesDisplay'
import QuoteNoteDisplay from '@/components/admin/QuoteNoteDisplay'
import Overview from '@/components/admin/Overview'
import DatabaseManager from '@/components/admin/DatabaseManager'
import DatabaseSearch from '@/components/admin/DatabaseSearch'
import DatabaseTableDisplay from '@/components/admin/DatabaseTableDisplay'
import GenerateStatsDisplay from '@/components/admin/GenerateStatsDisplay'
import Reports from '@/components/admin/Reports'
import PropertyDetailsDisplay from '@/components/admin/PropertyDetailsDisplay'
import CompanyDetailsDisplay from '@/components/admin/CompanyDetailsDisplay'
import DirectoryDisplay from '@/components/admin/DirectoryDisplay'
import MediaItem from '@/components/admin/MediaItem'
import Stats from '@/components/admin/Stats'
import ClientQuotes from '@/components/client/Quotes'
import ForgotPassword from '@/components/ForgotPassword'
import FeedbackDisplay from '@/components/admin/FeedbackDisplay'
import PublicPdf from '@/components/PublicPdf'
import TicketDetailsDisplay from '@/components/displays/TicketDetailsDisplay'

const render = function (h) {
  return h('div', [ h('router-view') ])
}

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/api/public/pdf/:uuid',
      component: PublicPdf,
      meta: {
        client: true
      }
    },
    {
      path: '',
      component: Layout,
      meta: {
        authType: 'admin'
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: Overview
        },
        {
          path: 'login',
          component: {
            name: 'Login',
            render
          },
          meta: {
            client: true,
            authType: 'public'
          },
          children: [
            {
              name: 'Login',
              path: '',
              component: VueForm,
              meta: {
                client: true,
                authType: 'public',
                vueForm: 'adminLogin',
                vueFormMethod: 'post',
                loginPage: true
              }
            }
          ]
        },
        {
          path: 'forgot-password',
          component: ForgotPassword,
          name: 'Forgot Password?',
          meta: {
            client: true,
            authType: 'public'
          }
        },
        {
          path: 'reset-password/:resetToken',
          component: {
            name: 'Reset Password',
            render
          },
          meta: {
            client: true,
            authType: 'public'
          },
          children: [
            {
              name: 'Reset Password',
              path: '',
              component: VueForm,
              meta: {
                client: true,
                authType: 'public',
                vueForm: 'resetPassword',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'feed-back/:quoteUuid',
          component: {
            name: 'FeedBack',
            render
          },
          meta: {
            client: true,
            authType: 'public'
          },
          children: [
            {
              name: 'Feedback',
              path: '',
              component: VueForm,
              meta: {
                client: true,
                authType: 'public',
                vueForm: 'feedBack',
                vueFormMethod: 'post'
              }
            }
          ]
        },
        {
          path: 'dashboard',
          component: Overview,
          name: 'Dashboard',
          meta: {
            client: true
          }
        },
        {
          path: 'database-search',
          component: DatabaseSearch,
          name: 'Database Search'
        },
        {
          path: 'account',
          name: 'My Account',
          component: VueForm,
          meta: {
            vueForm: 'editAccount',
            vueFormMethod: 'post',
            authType: 'admin',
            client: true
          }
        },
        {
          path: 'directory',
          name: 'Directory',
          component: DirectoryDisplay,
          meta: {
            authType: 'admin'
          }
        },
        {
          path: 'database-manager',
          component: {
            name: 'DatabaseManager',
            render
          },
          children: [
            {
              path: '',
              name: 'Database Manager',
              component: DatabaseManager,
              meta: {
                authType: 'admin'
              }
            },
            {
              path: 'report-info',
              name: 'Reports for Quotes',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'reportTypes',
                vueTitle: 'Reports for Quotes',
                newPermalink: 'newReportType',
                showSearch: true
              }
            },
            {
              path: 'staff',
              name: 'Roscon Staff',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'staff',
                vueTitle: 'Staff',
                newPermalink: 'newStaff',
                showSearch: true
              }
            },
            {
              path: "staff-tax-invoice-report",
              name: "Roscon Staff Tax Invoice Report",
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'staffTaxInvoiceReport',
                vueTitle: 'Staff Tax Invoice Report',
                showSearch: true
              }
            },
            {
              path: "epma",
              name: "24/7 EPMA Contracts",
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'EPMA',
                vueTitle: '24/7 EPMA',
                showSearch: true,
                newPermalink: 'newEPMA',
              }
            },
            {
              path: 'all-company-stats',
              name: 'Generate Stats for All Companies',
              component: GenerateStatsDisplay,
            },
            {
              path: 'contractors',
              name: 'Contractors',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'contractors',
                vueTitle: 'Contractors',
                newPermalink: 'newContractor',
                showSearch: true
              }
            },
            {
              path: 'ohs-locations-db',
              name: 'OH&S Hazard Locations',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'ohsHazardLocations',
                vueTitle: 'OH&S Hazard Locations',
                newPermalink: 'newOhsLocation',
                showSearch: true
              }
            },
            {
              path: 'ohs-findings-db',
              name: 'OH&S Hazard Findings / Recommendations',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'ohsHazardFindings',
                vueTitle: 'OH&S Hazard Findings / Recommendations',
                newPermalink: 'newOhsFinding',
                showSearch: true
              }
            },
            {
              path: 'esm-items-db',
              name: 'ESM Items',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'esmItems',
                vueTitle: 'ESM Items',
                newPermalink: 'newEsmItem',
                showSearch: true
              }
            },
            {
              path: 'esm-templates-db',
              name: 'ESM Templates',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'esmTemplates',
                vueTitle: 'ESM Templates',
                newPermalink: 'newEsmTemplate',
                showSearch: true
              }
            },
            {
              path: 'invoice-codes',
              name: 'Invoice Account Codes',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'invoiceAccountCodes',
                vueTitle: 'Invoice Account Codes',
                newPermalink: 'newInvoiceCode',
                showSearch: true
              }
            },
            {
              path: 'settings',
              name: 'Settings',
              component: VueForm,
              meta: {
                vueForm: 'editSettings',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              path: 'quote-videos',
              name: 'Videos',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'videos',
                vueTitle: 'Videos',
                newPermalink: 'newVideo'
              }
            },
            {
              path: 'media-items',
              name: 'General Roscon Website Media Items',
              component: MediaItem
            },
            {
              path: 'apps',
              name: 'Apps',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'apps',
                vueTitle: 'Apps',
                showSearch: true
              }
            },
            {
              path: 'oc-managers',
              component: {
                name: 'OC-Managers',
                render
              },
              children: [
                {
                  path: '',
                  name: 'OC Managers',
                  component: DatabaseTableDisplay,
                  meta: {
                    vueData: 'ocManagers',
                    vueTitle: 'OC Managers',
                    newPermalink: 'newManager',
                    showSearch: true,
                    allowExport: true
                  }
                },
                // Added ocManagerUuid to make Manager name as a hyperlink to edit its details under DatabaseSearch.
                {
                  path: ':ocManagerUuid',
                  name: 'OC Managers',
                  component: DatabaseTableDisplay,
                  meta: {
                    vueData: 'ocManagers',
                    vueTitle: 'OC Managers',
                    newPermalink: 'newManager',
                    showSearch: true,
                    allowExport: true
                  }
                }
              ]
            },
            {
              path: 'properties',
              component: {
                name: 'Properties',
                render
              },
              children: [
                {
                  name: 'Properties',
                  path: '',
                  component: DatabaseTableDisplay,
                  meta: {
                    vueData: 'properties',
                    vueTitle: 'Properties',
                    newPermalink: 'newProperty',
                    showSearch: true
                  }
                },
                {
                  path: ':propertyUuid',
                  component: PropertyDetailsDisplay,
                  meta: {
                    reload: 'loadProperty'
                  }
                }
              ]
            },
            {
              path: 'properties-excel',
              component: {
                name: 'PropertiesExcel',
                render
              },
              children: [
                {
                  name: 'Properties Excel',
                  path: '',
                  component: DatabaseTableDisplay,
                  meta: {
                    vueData: 'properties',
                    vueTitle: 'Properties Excel',
                    newPermalink: 'newPropertyExcel',
                    showSearch: true
                  }
                },
                {
                  path: ':propertyUuid',
                  component: PropertyDetailsDisplay,
                  meta: {
                    reload: 'loadProperty'
                  }
                }
              ]
            },
            // TODO: Create a serpate component for EPMA Properties identical to the current component
            // {
            //   path: 'properties-epma',
            //   component: {
            //     name: 'PropertiesExcel',
            //     render
            //   },
            //   children: [
            //     {
            //       name: 'Properties EPMA',
            //       path: '',
            //       component: DatabaseTableDisplay,
            //       meta: {
            //         vueData: 'properties',
            //         vueTitle: 'Properties EPMA',
            //         newPermalink: 'newPropertyEPMA',
            //         showSearch: true
            //       }
            //     },
            //     {
            //       path: ':propertyUuid',
            //       component: PropertyDetailsDisplay,
            //       meta: {
            //         reload: 'loadProperty'
            //       }
            //     }
            //   ]
            // },
            {
              path: 'oc-managers-feed',
              name: 'OC Managers Feed',
              component: OCManagersFeed,
              meta: {
                authType: 'admin'
              }
            },
            {
              path: 'property-costing',
              name: 'Property Costing',
              component: DatabaseTableDisplay,
              meta: {
                vueData: 'propertyCosting',
                vueTitle: 'Property Costing',
                newPermalink: 'newPropertyCosting',
                showSearch: false
              }
            },
            {
              path: 'companies',
              component: {
                name: 'Companies',
                render
              },
              children: [
                {
                  name: 'Companies',
                  path: '',
                  component: DatabaseTableDisplay,
                  meta: {
                    vueData: 'companies',
                    vueTitle: 'Companies',
                    newPermalink: 'newCompany',
                    showSearch: true
                  }
                },
                {
                  path: ':companyUuid',
                  component: CompanyDetailsDisplay,
                  meta: {
                    reload: 'loadCompany'
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'tax-invoice-requests',
          component: {
            name: 'TaxInvoiceRequests',
            render
          },
          children: [
            {
              path: '',
              name: 'Tax Invoice Requests',
              component: Reports,
              meta: {
                reportType: 'taxInvoiceRequest',
                authType: 'admin',
                showSearch: true
              }
            },
            {
              path: 'new',
              name: 'New Tax Invoice Request',
              component: VueForm,
              meta: {
                vueForm: 'newTaxInvoiceRequest',
                vueFormMethod: 'post',
                authType: 'admin'
              },
              children: [
                {
                  name: 'Generate Tax Invoice Request',
                  path: ':reportUuid',
                  component: VueForm,
                  meta: {
                    vueForm: 'newTaxInvoiceRequest',
                    vueFormMethod: 'post',
                    authType: 'admin'
                  }
                }
              ]
            },
            {
              path: 'edit/:invoiceUuid',
              name: 'Edit Tax Invoice Request',
              component: VueForm,
              meta: {
                vueForm: 'editTaxInvoiceRequest',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'live-feed',
          name: 'Live Feed',
          component: LiveFeed,
          meta: {
            authType: 'admin'
          }
        },
        {
          path: 'feed-back',
          name: 'Feedback',
          component: FeedbackDisplay,
          meta: {
            authType: 'admin'
          }
        },
        {
          path: 'stats',
          name: 'Stats',
          component: Stats,
          meta: {
            authType: 'admin'
          }
        },
        {
          path: '247-incident-reports',
          component: {
            name: 'IncidentReports',
            render
          },
          children: [
            {
              path: '',
              name: '24/7 Incident Reports',
              component: Reports,
              meta: {
                reportType: 'incidentReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New Incident Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'incidentReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Incident Report',
              path: 'edit/:incidentReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'incidentReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'inspection-reports',
          component: {
            name: 'InspectionReports',
            render
          },
          children: [
            {
              path: '',
              name: 'Inspection Reports',
              component: Reports,
              meta: {
                reportType: 'inspectionReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New Inspection Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'inspectionReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Inspection Report',
              path: 'edit/:inspectionReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'inspectionReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'property-photos',
          component: {
            name: 'PropertyPhotos',
            render
          },
          children: [
            {
              path: '',
              name: 'Property Photos',
              component: Reports,
              meta: {
                reportType: 'propertyPhotosReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New Property Photos Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'propertyPhotosReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Property Photos Report',
              path: 'edit/:propertyPhotosReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'propertyPhotosReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'asbestos-reports',
          component: {
            name: 'AsbestosReports',
            render
          },
          children: [
            {
              path: '',
              name: 'Asbestos Reports',
              component: Reports,
              meta: {
                reportType: 'asbestosReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New Asbestos Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'asbestosReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Asbestos Report',
              path: 'edit/:asbestosReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'asbestosReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'ohs-reports',
          component: {
            name: 'OHSReports',
            render
          },
          children: [
            {
              path: '',
              name: 'OH&S Reports',
              component: Reports,
              meta: {
                reportType: 'ohsReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New OH&S Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'ohsReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit OH&S Report',
              path: 'edit/:ohsReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'ohsReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'esm-reports',
          component: {
            name: 'ESMReports',
            render
          },
          children: [
            {
              path: '',
              name: 'ESM Reports',
              component: Reports,
              meta: {
                reportType: 'esmReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New ESM Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'esmReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit ESM Report',
              path: 'edit/:esmReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'esmReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'building-defect-reports',
          component: {
            name: 'BuildingDefectsReports',
            render
          },
          children: [
            {
              path: '',
              name: 'Building Defects Reports',
              component: Reports,
              meta: {
                reportType: 'defectsReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New Building Defects Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'defectsReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Building Defects Report',
              path: 'edit/:defectsReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'defectsReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Scott Schedule',
              path: 'scott-schedule/:defectsReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'defectsReportScottSchedule',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'insurance-reports',
          component: {
            name: 'InsuranceReports',
            render
          },
          children: [
            {
              path: '',
              name: 'Insurance Reports',
              component: Reports,
              meta: {
                reportType: 'insuranceReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New Insurance Report',
              path: 'new',
              component: VueForm,
              meta: {
                vueForm: 'insuranceReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Insurance Report',
              path: 'edit/:insuranceReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'insuranceReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'trades',
          component: {
            name: 'TradesReports',
            render
          },
          children: [
            {
              path: '',
              name: 'Trades',
              component: Reports,
              meta: {
                reportType: 'tradesReport',
                authType: 'admin',
                showSearch: true,
                editSettings: true
              }
            },
            {
              name: 'New Trades Report',
              path: 'new/:reportType',
              component: VueForm,
              meta: {
                vueForm: 'tradesReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Trades Report',
              path: 'edit/:tradesReportUuid',
              component: VueForm,
              meta: {
                vueForm: 'tradesReport',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'work-orders',
          component: {
            name: 'WorkOrders',
            render
          },
          children: [
            {
              path: '',
              name: 'Work Orders',
              component: QuotesDisplay,
              meta: {
                authType: 'admin',
                quoteType: 'acceptedQuotes',
                showSearch: true,
                addNew: {
                  workOrder: true
                }
              }
            },
            {
              name: 'New Work Order',
              path: 'new/:type',
              component: VueForm,
              meta: {
                vueForm: 'newQuote',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            }
          ]
        },
        {
          path: 'quotes',
          component: {
            name: 'Quotes',
            render
          },
          children: [
            {
              path: '',
              name: 'Quotes',
              component: QuotesDisplay,
              meta: {
                authType: 'admin',
                quoteType: 'propertyReporting',
                showSearch: true,
                editSettings: true,
                addNew: {
                  quote: true
                }
              }
            },
            {
              name: 'New Quote',
              path: 'new/:type',
              component: VueForm,
              meta: {
                vueForm: 'newQuote',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              name: 'Edit Quote',
              path: 'edit/:quoteUuid',
              component: VueForm,
              meta: {
                vueForm: 'editQuote',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            {
              path: 'notes/:quoteUuid',
              component: QuoteNoteDisplay
            },
            {
              path: ':quoteUuid',
              name: 'Quotes',
              component: QuotesDisplay,
              meta: {
                authType: 'admin',
                quoteType: 'propertyReporting',
                showSearch: true,
                editSettings: true,
                addNew: true
              }
            }
          ]
        },
        {
          path: 'client',
          component: {
            name: 'ClientApp',
            render
          },
          children: [
            {
              path: 'property-reporting',
              component: {
                name: 'TradesReports',
                render
              },
              children: [
                {
                  path: '',
                  name: 'Property Reporting',
                  component: ClientQuotes,
                  meta: {
                    authType: 'admin',
                    quoteType: 'propertyReporting',
                    showSearch: true,
                    client: true
                  }
                },
                {
                  name: 'New',
                  path: 'new/:reportType',
                  component: PropertyReportQuoteWizard,
                  meta: {
                    vueForm: 'propertyReporting',
                    vueFormMethod: 'post',
                    authType: 'admin',
                    client: true
                  }
                }
              ]
            },
            {
              path: 'manage-properties/:companyUuid',
              component: {
                name: 'ManageProperties',
                render
              },
              children: [
                {
                  path: '',
                  name: 'Manage Properties',
                  component: CompanyDetailsDisplay,
                  meta: {
                    client: true
                  }
                }
              ]
            },
            {
              path: 'property/:propertyUuid',
              name: 'View Property',
              component: PropertyDetailsDisplay,
              meta: {
                client: true,
                reload: 'loadProperty'
              }
            },
            {
              path: 'company-incident-reports',
              component: {
                name: 'IncidentReports',
                render
              },
              children: [
                {
                  path: '',
                  name: 'Company 24/7 Incident Reports',
                  component: Reports,
                  meta: {
                    client: true,
                    reportType: 'incidentReport',
                    showSearch: true
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'tickets',
          component: {
            name: 'Tickets',
            render
          },
          children: [
            {
              path: '',
              redirect: 'outstanding'
            },
            {
              path: 'outstanding/new',
              redirect: 'new'
            },
            {
              path: 'outstanding',
              name: 'Outstanding Tickets',
              component: VueCards,
              meta: {
                vueCards: 'tickets',
                authType: 'admin',
                showSearch: true,
                allowNew: true
              }
            },
            {
              path: 'completed',
              name: 'Completed Tickets',
              component: VueCards,
              meta: {
                vueCards: 'completedTickets',
                authType: 'admin',
                showSearch: true
              }
            },
            {
              path: 'new',
              name: 'New Ticket',
              component: VueForm,
              meta: {
                vueForm: 'newTicket',
                vueFormMethod: 'post',
                authType: 'admin'
              }
            },
            { path: ':ticketId', component: TicketDetailsDisplay }
          ]
        },
        {
          path: '*',
          component: NotFoundError,
          meta: {
            client: true,
            public: false
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js